import React from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { IEscalatedIssuesQuery } from '../../graphql/EscalatedIssues'
import { IssueNotificationRow } from '../IssueNotificationRow'

const useIssuesNotificationsStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(1, 3),
    marginTop: 0,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 0),
  },
  count: {
    backgroundColor: brandColors.skyBlue1,
    borderRadius: '4px',
    padding: '2px 4px',
  },
  issueList: {
    display: 'grid',
    gridTemplateColumns: '1.5fr minmax(100px, 4fr) 1fr 3.5fr minmax(50px, 2fr)',
    '& > div': {
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      padding: theme.spacing(1.5),
      paddingLeft: 0,
      display: 'flex',
      alignItems: 'center',
    },
  },
}))

interface IIssuesNotificationsProps {
  className?: string
  escalatedIssues: IEscalatedIssuesQuery['paginatedShipmentIssues']['nodes']
  issueCount: number
}

const issuesListUrl = `${__ROOT__}/issues?userEscalated=1`

export const IssuesNotifications = ({
  className,
  escalatedIssues,
  issueCount,
}: IIssuesNotificationsProps) => {
  const classes = useIssuesNotificationsStyles()

  if (!escalatedIssues?.length) return null

  return (
    <div className={className}>
      <div className={classes.container}>
        <div className={classes.header}>
          <Typography variant='subtitle2'>Most Recently Escalated</Typography>
          <Typography variant='button'>
            <a href={issuesListUrl} target='_blank' rel='noopener noreferrer' data-test='cta-link'>
              see all <span className={classes.count}>{issueCount}</span>
            </a>
          </Typography>
        </div>
        <div className={classes.issueList}>
          {escalatedIssues.map(issue => {
            if (!issue) return null
            return <IssueNotificationRow key={issue.id} issue={issue} />
          })}
        </div>
      </div>
    </div>
  )
}
